import preferencesConfigAction from './actions';
import countryManagementStore from './store';

const countryManagementActions = {
  preferencesConfigAction,
};

export { countryManagementStore, countryManagementActions };
